import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface AmchartsLicConfig {
  licence: string;
}

export const amchartLicConfig: AmchartsLicConfig = {
  licence: environment.amchartsLic,
};

export const AMCHART_LIC_CONFIG = new InjectionToken<AmchartsLicConfig>('amchartsLicConfig');
